import { CrmUser } from "./user.model";

export class PaymentTerm {
    constructor(
        public id: number = 0,
        public code: string = null,
        public name: string = null,
        public description: string = null,
        public createdByUserAccount: CrmUser = null,
        public createdByUserAccountId: number= null,
        public createdOn: string = null,
        public updatedByUserAccount: CrmUser = null,
        public updatedByUserAccountId: number = null,
        public updatedOn: string = null,
        public status: string = null
    ) { }
}
